import React from "react";

import Router from "./routes";

export default function App(): any {
    return <Router />;
}
